<template>
    <v-dialog
      v-model="serviceDownDialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Click Me
        </v-btn>
      </template>

      <v-card>
        <v-card-title dark class="blue title">
          <span>INTERIOR GIS SERVICES OFFLINE</span>
          <v-spacer></v-spacer>
          <v-icon @click="closeDialog">close</v-icon>
        </v-card-title>

        <v-card-text>
          This may be part of the five minute daily update.  If this error persists, please notify.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="btnClick"
          >
            Notify
          </v-btn>
          
          <v-btn
            color="primary"
            text
            @click="reload"
          >
            Refresh
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
</template>

<script>
export default {
  props: ['serviceDownDialog'],

    data () {
		return {
			//showDialog: this.serviceDownDialog
		}
	},

  methods: {
    btnClick () {
      this.$router.push({name: "feedback"})
    },

    closeDialog() {
      this.$emit('closeDialog')
    },

    reload() {
      location.reload()
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/GISServiceDownDialog.vue